import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ActualSuppliers from "../components/Search/ActualSuppliers";
import SalesOrdersHttpHandler from "../apiClient/SalesOrder/GetList";
import Preloader from '../components/Preloader';

class SalesOrdersPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      salesOrders: []
    }
  }

  componentDidMount() {

    SalesOrdersHttpHandler.getAll().subscribe(salesOrders => {
      this.setState({
        salesOrders: salesOrders
      })
    });
  }

  render() {
    return (
      <div className="container-search-page">
        {this.state.salesOrders.length ?
            <ActualSuppliers
                salesOrders={this.state.salesOrders}
                cultures={this.props.cultures}
            /> :
            <Preloader/>
        }
      </div>
    );
  }
}

SalesOrdersPage.propTypes = {
  cultures: PropTypes.array,
};

const mapStateToProps = state => ({
  cultures: state.webInterface.initData.cultures,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SalesOrdersPage);



// WEBPACK FOOTER //
// ./containers/SalesOrdersPage.js